import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

const SEOReportGraph = () => {
  const [chartConfig, setChartConfig] = useState({
    series: [70], // Change this to test different percentages
    options: {
      chart: {
        height: 350,
        type: "radialBar",
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: "40%",
          },
          track: {
            strokeWidth: "50%",
          },
          dataLabels: {
            show: false,
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal", // Horizontal gradient
          gradientToColors: ["#FFA500", "#008000"], // Orange to green
          stops: [0, 30, 60, 100], // Define gradient stops (percentages)
          colorStops: [
            {
              offset: 0,
              color: "#FF0000", // Red
              opacity: 1,
            },
            {
              offset: 33,
              color: "#FFA500", // Orange
              opacity: 1,
            },
            {
              offset: 66,
              color: "#008000", // Green
              opacity: 1,
            },
          ],
        },
      },
    },
  });

  const percentage = chartConfig.series[0];

  return (
    <div style={{ textAlign: "center" }}>
      <ReactApexChart
        options={chartConfig.options}
        series={chartConfig.series}
        type="radialBar"
        height={250}
      />
      <div className="w-50 m-auto">
        <div
          className="border p-2 rounded-1 bg-success-subtle fw-bold"
          style={{ fontSize: "12px", marginTop: -30 }}
        >
          {percentage} / 100
        </div>
      </div>
    </div>
  );
};

export default SEOReportGraph;
